function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { IconWrapper } from '../IconWrapper';
export var EcommExclamationMarkCircleIcon = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z",
    fill: "#222",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16C11 15.4477 11.4457 15 11.9955 15H12.0045C12.5543 15 13 15.4477 13 16 13 16.5523 12.5543 17 12.0045 17H11.9955C11.4457 17 11 16.5523 11 16zM12 13C11.4477 13 11 12.5726 11 12.0455V6.95455C11 6.42736 11.4477 6 12 6 12.5523 6 13 6.42736 13 6.95455V12.0455C13 12.5726 12.5523 13 12 13z",
    fill: "#222",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
});
//# sourceMappingURL=EcommExclamationMarkCircleIcon.js.map